import React, { FC } from 'react';
import { Image as ImageMedia } from '@fiverr-private/media';

const RESPONSIVE_IMAGE_CONFIG = {
  breakpoints: [
    { media: '(min-width: 900px)', viewportWidth: '430px', imageWidth: 430 },
    { media: '(min-width: 480px)', viewportWidth: '600px', imageWidth: 860 },
    { media: null, viewportWidth: '430px', imageWidth: 300 },
  ],
  additionalSrcSet: [{ imageWidth: 600 }],
};

function getImageData(url: string) {
  const isImageScalable = /w_[0-9]{3,4}/.test(url);

  if (!isImageScalable) {
    return {
      srcSet: undefined,
      sizes: undefined,
      defaultSrc: url,
    };
  }

  const allWidths = [
    ...RESPONSIVE_IMAGE_CONFIG.breakpoints.map((bp) => bp.imageWidth),
    ...RESPONSIVE_IMAGE_CONFIG.additionalSrcSet.map((item) => item.imageWidth),
  ];

  const srcSetEntries = allWidths.map((width) => {
    const modifiedUrl = url.replace(/w_[0-9]{3,4}/, `w_${width}`);
    return `${modifiedUrl} ${width}w`;
  });

  const sizesEntries = RESPONSIVE_IMAGE_CONFIG.breakpoints
    .filter((bp) => bp.media !== null)
    .map((bp) => `${bp.media} ${bp.viewportWidth}`)
    .concat(RESPONSIVE_IMAGE_CONFIG.breakpoints.find((bp) => bp.media === null)?.viewportWidth || '430px');

  const largestWidth = Math.max(...allWidths);
  const defaultSrc = url.replace(/w_[0-9]{3,4}/, `w_${largestWidth}`);

  return {
    srcSet: srcSetEntries.join(', '),
    sizes: sizesEntries.join(', '),
    defaultSrc,
  };
}

interface GuideImageProps {
  src: string;
  alt: string;
}

export const GuideImage: FC<GuideImageProps> = ({ src, alt = '', ...props }) => {
  if (!src) {
    return null;
  }

  const { srcSet, sizes, defaultSrc } = getImageData(src);

  return (
    <ImageMedia
      srcSet={srcSet}
      sizes={sizes}
      src={defaultSrc}
      alt={alt}
      title={alt}
      loading="lazy"
      borderRadius="sm"
      width="100%"
      height="100%"
      objectFit="cover"
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      display="block"
      {...props}
    />
  );
};
